import * as React from 'react';

const RequiredIcon = function (props: { required: boolean }) {
	if (!props.required) {
		return null;
	}
	return <span className="required-icon">*</span>;
}

export default RequiredIcon;